import React, { useEffect, useLayoutEffect } from 'react';
import { useSession } from '@/providers/Session.provider';
import { useLogTimestamp } from '@/providers/LogTimestamp.provider';
import { useClientLogin } from '@/providers/ClientLogin.provider';
import { useDatadogLog } from '@/hooks/useDatadogLog';

export default function SessionManager({ children }: { children: React.ReactNode }) {
  const { startSession, endSession } = useSession();
  const { updateTimestamp } = useLogTimestamp();
  const { isAuthenticated } = useClientLogin();
  const { datadogLog } = useDatadogLog();

  useLayoutEffect(() => {
    if (isAuthenticated) {
      startSession();
      updateTimestamp(Date.now());
    } else {
      datadogLog({
        message: 'Logged out',
        payload: {},
        actionType: 'End',
      });
      endSession();
    }
  }, [isAuthenticated, startSession]);

  useEffect(() => {
    const handleBeforeUnload = () => {
      datadogLog({
        message: 'Session closed',
        payload: {},
        actionType: 'End',
      });
      endSession();
    };
    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  });

  return <>{children}</>;
}
